import React, { useState } from 'react'
import { Col, Container, Modal, Row } from 'react-bootstrap';
import BlueTitleBack from '../Components/Widgets/BlueTitleBack';
import uuid from 'react-uuid';
import InputField from '../Components/Widgets/InputField';

import { MdClose } from "react-icons/md";

import moment from 'moment';
import { formatNumber } from '../../utils';
import InputFieldCurrency from '../Components/Widgets/InputFieldCurrency';


const initState = { registration_date: moment().format("YYYY-MM-DD"), status_id: 2, parameter_id: 0, observation: '', parameter_group_id: 0 };
const ModalAddExpense = ({ show, onHide, listBranch, listParameterGroup, onSubmit,
    onOpenParameter, title, typeData, type, available }) => {
    const [form, setForm] = useState(initState)
    const [errors, setErrors] = useState({})
    const [listParameter, setListParameter] = useState([])
    const [error, setError] = useState('')

    const updateInput = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })

        if (e.target.name === 'parameter_group_id') {
            setListParameter(listParameterGroup.filter(f => parseInt(f.id) === parseInt(e.target.value))[0].children)
        }
    }

    const updateInputSelect = (e) => {
        let paramGroup = listParameterGroup.filter(row => row.id === parseInt(form.parameter_group_id))[0]
        let param = paramGroup.children.filter(p => p.parameter_id === parseInt(e.target.value))[0].parameter
        console.log('param', param);

        setForm({
            ...form,
            [e.target.name]: e.target.value,
            ["text"]: param.description
        })
    }

    const printWorker = (row) => {
        return <option key={row.id} value={row.id}>{row.description}</option>
    }

    const printConcept = (row) => {
        let { parameter } = row
        return <option key={row.id} value={parameter.id}>{parameter.description}</option>
    }


    const onSubmitTmp = () => {
        let _form = form

        let paramGroup = listParameterGroup.filter(row => row.id === parseInt(form.parameter_group_id))[0]
        let parameter = paramGroup.children.filter(p => p.parameter_id === parseInt(form.parameter_id))[0].parameter

        _form.parameter = parameter

        _form.concept = parameter.description
        _form.type = 1
        _form.date = form.registration_date;
        _form.expense = _form.amount;
        _form.status_id = 2;
        _form._id = uuid();

        if (available < _form.amount) {
            if (window.confirm("No tienes Cupo suficiente, deseas continuar?")) {
                onSubmit(_form)
                setForm(initState)
            }
        } else {
            onSubmit(_form)
            setForm(initState)
        }


    }

    return (
        <Modal show={show} onHide={onHide}>
            <div className="modal-header border-bottom-custom mt-2">
                <BlueTitleBack title={`Agregar Pago con ${type}`} />
                <button type="button" className="close p-0 m-0" data-dismiss="modal" aria-label="Close" onClick={onHide}>
                    <MdClose />
                </button>
            </div>
            <Modal.Body>
                <Container>
                    <Row>
                        <Col>
                            <div className="form-group">
                                <label>Fecha de Registro</label>
                                <input type={"date"} className='form-control' name='registration_date' value={form.registration_date} onChange={updateInput} />
                            </div>
                        </Col>
                    </Row>
                    <Row className='d-flex justify-content-center'>
                        <Col>
                            <div className="form-group">
                                <label>Grupo</label>
                                <select className="form-control" name="parameter_group_id" value={form.parameter_group_id} onChange={updateInput}>
                                    <option>Seleccione</option>
                                    {listParameterGroup.map(printWorker)}
                                </select>
                                {errors.parameter_group_id !== undefined && (<label className="error-label">{errors.parameter_group_id}</label>)}

                            </div>
                        </Col>
                    </Row>
                    <Row className='d-flex justify-content-center'>
                        <Col xs={8}>
                            <div className="form-group">
                                <label>Concepto</label>
                                <select className="form-control" name="parameter_id" value={form.parameter_id} onChange={updateInputSelect}>
                                    <option>Seleccione</option>
                                    {listParameter.map(printConcept)}
                                </select>
                                {errors.parameter_id !== undefined && (<label className="error-label">{errors.parameter_id}</label>)}

                            </div>
                        </Col>
                        <Col className='d-flex align-items-center'>
                            <button className='btn btn-info' onClick={() => onOpenParameter(title, typeData)}>Agregar</button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="form-group">
                                <label>Observación</label>
                                <input className='form-control' name="observation" value={form.observation || ''} onChange={updateInput} />
                            </div>
                        </Col>
                    </Row>
                    <Row>

                        <Col>
                            <div className="form-group">
                                <label>Monto</label>
                                <InputFieldCurrency
                                    name={"amount"}
                                    placeholder="Monto"
                                    onValueChange={(value, name) => setForm({ ...form, [name]: value })}
                                    error={errors.amount}
                                />
                                {/* <InputField
                                    type="number"
                                    placeholder={"Monto"}
                                    value={form.amount || ''}
                                    name="amount"
                                    onChange={updateInput}
                                    error={errors.amount}
                                /> */}
                            </div>
                        </Col>
                        {/* <Col>
                            <div className="form-group">
                                <label>Estado Pago</label>
                                <select className='form-control' name='status_id' value={form.status_id} onChange={updateInput}>
                                    <option value={1}>Pendiente Pago</option>
                                    <option value={2}>Pagado</option>
                                </select>

                            </div>
                        </Col> */}
                    </Row>
                    <Row>
                        <Col className='text-center'>
                            {available < 0 ? (<><label>No tienes Suficiente Disponible </label><h4 className='text-danger'>{formatNumber(available)}</h4></>) :
                                <span >Disponible para uso <h4 className={`${available < 0 ? 'text-danger' : 'text-success'}`}>{formatNumber(available)}</h4></span>}
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <Row >
                    <Col>
                        <button className='btn btn-danger' onClick={onHide}>Cerrar</button>
                    </Col>
                    <Col>
                        <button className={`btn ${available < 0 ? 'btn-warning' : 'btn-success'}`} onClick={onSubmitTmp}>Guardar</button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalAddExpense;